<template>
  <div
    class="loading-indicator"
    :class="{
      'loading-indicator--dark': dark,
      'loading-indicator--transparent': transparent,
      'in-relative': inRelative,
    }"
  >
    <div
      v-if="variant === 'spinner'"
      class="spinner-icon-wrapper"
    >
      <div class="spinner-icon" />
    </div>

    <div
      v-if="variant === 'spinnerLocal'"
      :class="spinoff ? `spinner-local__wrapper--${spinoff}` : ''"
      class="spinner-local__wrapper"
    >
      <div
        :class="spinoff ? `spinner-local__circle--${spinoff}` : null"
        class="spinner-local__circle"
      />
    </div>

    <div
      v-if="variant === 'spinnerCentered'"
      class="spinner-icon-wrapper spinner-icon-wrapper--centered"
    >
      <div class="spinner-icon spinner-icon--centered" />
    </div>

    <div
      v-if="isFullPage"
      :class="{
        'spinner-full-page__wrapper': true,
        'spinner-full-page__wrapper--cover': variant === 'spinnerFullPageCover',
      }"
    >
      <div class="spinner-full-page__circle" />
    </div>

    <div
      v-if="variant === 'spinnerCard'"
      :class="spinoff ? `spinner-card__wrapper--${spinoff}` : ''"
      class="spinner-card__wrapper"
    >
      <div
        :class="spinoff ? `spinner-card__circle--${spinoff}` : null"
        class="spinner-card__circle"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  dark?: boolean;
  transparent?: boolean;
  variant?: string;
  spinoff?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
  dark: false,
  transparent: false,
  variant: 'spinner',
  spinoff: null,
});

const inRelative = computed(() => {
  return props.spinoff && /^in-relative-/.test(props.spinoff);
});

const isFullPage = computed(() => {
  return props.variant === 'spinnerFullPage' || props.variant === 'spinnerFullPageCover';
});
</script>

<style scoped src="./loading-indicator" />
